import { render, staticRenderFns } from "./SharedCatalogBlock.vue?vue&type=template&id=aa0a6c1e&"
import script from "./SharedCatalogBlock.vue?vue&type=script&lang=js&"
export * from "./SharedCatalogBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiFilter: require('/app/components/UI/UiFilter.vue').default})
